var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.brand] = true, _obj[_vm.$style.compatible] = _vm.forceShowLabel || !_vm.isGenuine, _obj )},[_c('span',[_vm._v(_vm._s(_vm.$t('Switch & Save')))])])}
var staticRenderFns = []

export { render, staticRenderFns }